"use client";
import { useEffect } from "react";
import type { FullStoryParameters } from ".";
import { FullStory } from ".";
import { usePathname } from "next/navigation";

export const FullStoryClient = (parameters: FullStoryParameters) => {
  const pathName = usePathname();
  useEffect(() => {
    FullStory.initialize(parameters);
  }, [parameters]);

  useEffect(() => {
    void FullStory.setProperties({
      properties: { variant: "DotNext" },
      type: "page",
    });
  }, [pathName]);

  return <link href="https://edge.fullstory.com" rel="dns-prefetch" />;
};
